import { LembreteModel } from 'view/atendimentos/detail/soap/aside/types/LembreteModel'

export const filterMostrarInativos = (mostrarInativos: boolean) => (lembrete: LembreteModel) => {
  return mostrarInativos ? true : lembrete.historicoLembrete?.[0].ativo
}
